module.exports = __webpack_public_path__ + "img/4.d9bb5b8c.jpg";